import { Alert, Icon, Typography } from "@firecms/ui";

import { CMS_COLLECTION_DOWNLOAD_HINTS } from "../../WebDownloadsManager.constants";
import { useWebDownloadsInfoAccordion } from "../../hooks/useWebDownloadsInfoAccordion";

const WebDownloadsInfoAccordion: React.FC = () => {
  const { isExpanded, toggle } = useWebDownloadsInfoAccordion();

  return (
    <Alert color="info" className="p-0">
      <button
        type="button"
        className="flex w-full cursor-pointer items-center gap-2 border-none bg-transparent p-4 text-left"
        aria-expanded={isExpanded}
        onClick={toggle}
      >
        <span
          className={`inline-flex shrink-0 transition-transform ${isExpanded ? "rotate-180" : "rotate-0"}`}
          aria-hidden
        >
          <Icon iconKey="expand_more" size="small" />
        </span>
        <Typography variant="body2" className="font-medium">
          Was gehört unter <code>web/downloads/</code>?
        </Typography>
      </button>

      {isExpanded ? (
        <div className="flex flex-col gap-3 border-t border-surface-200 px-4 pb-4 pt-3 dark:border-surface-700">
          <Typography variant="body2">
            Hier verwaltest du <strong>öffentliche Web-Downloads</strong> unter <code>web/downloads/</code> — z. B.
            Newsletter-Anhänge, Lead-Magnete, Handouts oder freie MP3s mit Link <code>/downloads/…</code> auf der
            Website.
          </Typography>
          <Typography variant="body2">
            Downloads, die zu einem CMS-Inhalt gehören, gehören <strong>nicht</strong> hierher. Lade sie direkt in der
            jeweiligen Collection hoch:
          </Typography>
          <ul className="list-disc space-y-1 pl-5 text-sm">
            {CMS_COLLECTION_DOWNLOAD_HINTS.map((hint) => (
              <li key={hint.collectionName}>
                <strong>{hint.collectionName}</strong> — {hint.uploadLocation}
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </Alert>
  );
};

export default WebDownloadsInfoAccordion;
